import { User } from './types';

export const defaultUser: User = {
  email: '',
  firstName: '',
  lastName: '',
  msid: '',
  version: '',
};
